import { render, staticRenderFns } from "./ItemLinhaPreenchimento.vue?vue&type=template&id=3ddee5ba&scoped=true"
import script from "./ItemLinhaPreenchimento.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemLinhaPreenchimento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemLinhaPreenchimento.vue?vue&type=style&index=0&id=3ddee5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddee5ba",
  null
  
)

export default component.exports